import React from "react";
import { Link } from "react-router-dom";
import "../stylesheets/cardBox.css";
import PropTypes from "prop-types";


const Cardbox = (props) => (
  <div className="card-box-main">
    <div className="card-box">
      <div className="card-box-title">
        <Link
          to={props.path}
          style={{
            fontSize: "25px",
            fontWeight: "bold",
            textDecoration: "none",
            fontFamily: "Work Sans",
            color: "rgb(95, 40, 215) ",
          }}
        >
          {props.title}
        </Link>
      </div>
      <div
        className="card-box-paragraph"
        style={{
          display: "flex",
          justifyContent: "space-between",
          flexDirection: "column",
          height: "100%",
        }}
      >
        <p style={{ textAlign: "left" }}>{props.info}</p>

        {props.list ? (
          <div
            className="card-btn-main"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-around",
              flexDirection: "row",
              height: "100%",
              gap: "5px",
            }}
          >
            {props.list.map((item, index) => {
              return (
                <button key={item}>
                  <Link
                    to={item}
                    style={{
                      color: "white",
                      fontWeight: "bold",
                      textDecoration: "none",
                      fontFamily: "Work Sans",
                    }}
                  >
                    level {index + 1}
                  </Link>
                </button>
              );
            })}
          </div>
        ) : null}
      </div>
    </div>
  </div>
);

Cardbox.propTypes = {
  path: PropTypes.string,
  title: PropTypes.string,
  info: PropTypes.string,
  list: PropTypes.array,
};

export default Cardbox;
